<template>
    <div>
        <div class="search-wrap">
            <div class="search">
                <div class="search-hot">
                    <p class="title">搜索热词：</p>
                    <p
                        class="hot-word"
                        v-for="(item, i) in hotList"
                        :key="i"
                        :class="{'blue':currentHot == item.id}"
                        @click="hotSearch(item)"
                    >{{item.name}}</p>
                </div>
                <div class="flex-x">
                    <el-input v-model="content" placeholder="请输入搜索的内容" />
                    <el-button type="primary" icon="el-icon-search" @click="articleSearch">站内搜索</el-button>
                </div>
            </div>
            <div class="flex-y select">
                <div class="flex-left search-bot">
                    <p>文章类别：</p>
                    <el-checkbox-group v-model="currentType">
                        <el-checkbox
                            v-for="(item,i ) in classList"
                            :key="i"
                            :label="item.id"
                        >{{item.label}}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div class="flex-left search-bot">
                    <p>发表时间：</p>
                    <el-radio-group v-model="currentTime">
                        <el-radio
                            v-for="(item,i ) in timeList"
                            :key="i"
                            :label="item.id"
                        >{{item.name}}</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div
            class="article-list"
            id="main-container"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
        >
            <el-container>
                <el-aside>
                    <p class="title">首页/论文知库</p>
                    <NavMenu :list="listNav" @menuChange="selectMenu" :level="2" ref="menu"></NavMenu>
                    <div class="option">
                        <ul class="art-class select-type">
                            <div class="title">论文集</div>
                            <li
                                v-for="(item, i) in proceedings"
                                :class="{'blue':currentPaper == item.id}"
                                :key="i"
                                @click="selectPaper(item.id)"
                            >{{item.label}}</li>
                        </ul>
                    </div>
                    <ListAdv :ListAdv="ListAdv"></ListAdv>
                </el-aside>
                <el-main id="main">
                    <p class="result">找到{{total}}条相关结果</p>
                    <div class="expert-wrap">
                        <div
                            v-for="single in articleList"
                            :key="single.id"
                            v-show="articleList.length > 0"
                        >
                            <single-article :single="single"></single-article>
                        </div>
                    </div>
                    <el-pagination
                        v-if="total>0"
                        background
                        layout="jumper, prev, pager, next, slot, total"
                        :total="total"
                        :current-page="page"
                        @current-change="currentChange"
                        @prev-click="prevClick"
                        @next-click="nextClick"
                    >
                        <!-- <span class="el-pagination__total"> 共 {{ pageCount }} 页，</span> -->
                    </el-pagination>
                </el-main>
            </el-container>
        </div>
    </div>
</template>

<script>
    import SingleArticle from '../../components/common/SingleArticle';
    import NavMenu from '../../components/content/nav-menu';
    import ListAdv from '../../components/common/ListAdv';
    export default {
        components: {
            SingleArticle,
            NavMenu,
            ListAdv
        },
        props: {},
        data() {
            return {
                total: 0,
                label: '',
                level: '',
                listNav: [],
                articleList: [],
                proceedings: [], // 论文集二级分类列表
                hotList: [],
                loading: false,
                content: '',
                classList: [],
                currentTime: 'all',
                currentType: [],
                currentHot: '',
                currentPaper: '',
                konwledgeId: '',
                pagesId: '',
                timeList: [
                    {
                        name: '全部',
                        id: 'all'
                    },
                    {
                        name: '最近一周',
                        id: 'week'
                    },
                    {
                        name: '最近一月',
                        id: 'month'
                    },
                    {
                        name: '最近半年',
                        id: 'halfyear '
                    },
                    {
                        name: '最近一年',
                        id: 'year'
                    }
                ],
                method: '',
                page: 1,
                size: 10,
                ListAdv: []
            };
        },
        computed: {
            pageCount() {
                let count = 0;
                let total = Number(this.total);
                if (total) {
                    if (total % 10 === 0) {
                        count = total / 10;
                    } else {
                        count = Math.floor(total / 10) + 1;
                    }
                }
                return count;
            }
        },
        created() {
            if (this.$route.query.name) {
                this.content = this.$route.query.name;
            }
            this.getNavList();
            this.getHotWords();
            this.getAdvertise();
        },
        mounted() {},
        watch: {},
        methods: {
            getAdvertise() {
                this.httpGet(this.$root.getAdvList)
                    .then(res => {
                        this.ListAdv = res.DetailList.slice(0, 2);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('ListAdv-err', err);
                    });
            },
            getHotWords() {
                this.httpGet(this.$root.getHotWords)
                    .then(res => {
                        this.hotList = res;
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('getNavList-err', err);
                    });
            },
            selectPaper(id) {
                // 选择论文集
                this.$refs.menu.clearData();
                this.currentTime = 'all';
                this.currentType = [];
                this.currentPaper = id;
                this.level = id;
                this.getArticleList();
            },
            selectMenu(id) {
                this.currentTime = 'all';
                this.currentType = [];
                this.currentPaper = '';
                this.level = id;
                this.getArticleList();
            },
            getNavList() {
                // 获取全部分类
                this.httpGet(this.$root.getAboutUs)
                    .then(res => {
                        // 根据一级导航获取论文集论文知库的id
                        res.list.fixedClass.forEach(item => {
                            if (['论文知库'].includes(item.label)) {
                                this.konwledgeId = item.id;
                                this.classList = item.children;
                            }
                            if (['论文集'].includes(item.label)) {
                                this.pagesId = item.id;
                                this.proceedings = item.children;
                            }
                        });
                        console.log(111, this.classList, this.proceedings);
                        // 整理结构
                        // this.classList.forEach(item => {
                        // if (!item.children.length) {
                        //   delete item.children;
                        //   item.children = [];
                        // }
                        // });
                        // 论文知库获取分类
                        let str = JSON.stringify(this.classList);
                        let str1 = str.replace(/label/g, 'mname');
                        this.listNav = JSON.parse(str1);
                        this.listNav.unshift({
                            id: this.konwledgeId,
                            mname: '全部',
                            children: []
                        });
                        console.log(2222, this.listNav);
                        // 获取全部论文知库文章
                        this.level = this.konwledgeId;
                        this.getArticleList();
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('getNavList-err', err);
                    });
            },
            getArticleList() {
                this.method = 'list';
                this.loading = true;
                this.httpGet(this.$root.getArticleList, {
                    class_id: this.level
                })
                    .then(result => {
                        this.articleList = result.list;
                        if (result.count) {
                            this.total = Number(result.count);
                        } else {
                            this.total = 0;
                        }
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('articleList-err', err);
                    });
            },
            hotSearch(item) {
                this.page = 1;
                this.currentTime = 'all';
                this.currentType = [];
                this.currentPaper = '';
                this.content = item.name;
                this.currentHot = item.id;
                this.articleSearch();
            },
            articleSearch() {
                this.page = 1;
                this.method = 'search';
                this.$refs.menu.clearData();
                this.currentPaper = '';
                this.loading = true;
                this.httpGet(this.$root.stationSearch, {
                    id: this.konwledgeId,
                    date: this.currentTime,
                    class: this.currentType,
                    content: this.content,
                    page: this.page,
                    size: this.size
                })
                    .then(result => {
                        if (result.count) {
                            this.articleList = result.list;
                            this.total = Number(result.count);
                        } else {
                            this.articleList = [];
                            this.total = 0;
                        }
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('articleList-err', err);
                    });
            },
            currentChange(page) {
                this.page = page;
                this.articleList = [];
                if (this.method == 'search') {
                    this.articleSearch();
                } else {
                    this.getArticleList();
                }
            },
            prevClick(page) {
                this.page = page;
                this.articleList = [];
                if (this.method == 'search') {
                    this.articleSearch();
                } else {
                    this.getArticleList();
                }
            },
            nextClick(page) {
                this.page = page;
                this.articleList = [];
                if (this.method == 'search') {
                    this.articleSearch();
                } else {
                    this.getArticleList();
                }
            }
        }
    };
</script>

<style lang='stylus' rel='stylesheet/stylus' scoped>
    @import '~assets/main.styl';

    .blue {
        color: #197DFF !important;
    }

    .flex-x {
        flex-x();
    }

    .flex-y {
        flex-y();
    }

    .flex-left {
        flex-x(flex-start);
    }

    #main-container {
        // min-height: 520px;
        margin-top: 20px;
    }

    .expert-wrap {
        // min-height: 520px;
        width: 880px;
        margin-top: 15px;
        border-radius: 8px;
        overflow: hidden;
    }

    #main-container {
        .title {
            margin-bottom: 10px;
        }

        .result {
            margin-bottom: 10px;
            font-size: 12px;
            color: gray6;
        }
    }

    .el-main {
        padding: 0 20px;
    }

    >>>.el-pagination {
        width: 880px;
        flex-center();
        padding: 20px;
        box-sizing: border-box;
        background: white;
        margin-top: 20px;
    }

    .search-wrap {
        width: 100%;
        background: white;
        min-height: 180px;
        flex-y();
        padding: 40px;
        box-sizing: border-box;
    }

    .search-bot {
        margin: 10px 20px 10px 0;
        // width: 620px;
        flex-x(flex-satrt, flex-start);

        p {
            margin-right: 10px;
            color: gray9;
            width: 70px;
            flex-shrink: 0;
        }
    }

    .search {
        width: 740px;

        .search-hot {
            flex-x(flex-start);
            margin-bottom: 10px;

            .hot-word {
                cursor: pointer;
            }

            .title {
                color: gray3;
            }

            p {
                color: gray9;
                margin-right: 30px;
            }
        }
    }

    .select {
        width: 1180px;
        // max-width 1180px
        margin: auto;
        margin-top: 10px;
        flex-y(space-between, flex-start);
    }

    .option {
        .select-type {
            width: 100%;
            background: white;
            border-radius: 8px;
            padding: 16px;
            box-sizing: border-box;
            margin-top: 20px;

            li {
                height: 40px;
                line-height: 40px;
                padding-left: 20px;
                box-sizing: border-box;
                cursor: pointer;
                font-size: 14px;
            }

            .title {
                height: 40px;
                width: 100%;
                background: #F0F5FA;
                line-height: 40px;
                padding-left: 20px;
                box-sizing: border-box;
                position: relative;
                font-size: 14px;
                font-weight: bold;

                &::before {
                    content: '';
                    position: absolute;
                    top: 10px;
                    left: 0;
                    width: 4px;
                    height: 20px;
                    background: #4093FF;
                }
            }
        }
    }
</style>
